import { SITE_ORIGIN } from "./hreflang";

/**
 * Static SEO guide pages (separate HTML per locale).
 * Slugs use romanized keywords matching each locale’s search terms.
 */
export const GUIDE_PAGES = {
  en: {
    lang: "en",
    path: "/how-drop-chances-work",
    publicDir: "how-drop-chances-work",
    assetPrefix: "../../build",
  },
  es: {
    lang: "es",
    path: "/es/como-funcionan-las-probabilidades-de-drop",
    publicDir: "es/como-funcionan-las-probabilidades-de-drop",
    assetPrefix: "../../../build",
  },
  ja: {
    lang: "ja",
    path: "/ja/doroppu-kakuritsu-no-shikumi",
    publicDir: "ja/doroppu-kakuritsu-no-shikumi",
    assetPrefix: "../../../build",
  },
  ko: {
    lang: "ko",
    path: "/ko/deureop-yul-gyesan-bangsig",
    publicDir: "ko/deureop-yul-gyesan-bangsig",
    assetPrefix: "../../../build",
  },
  zh: {
    lang: "zh",
    path: "/zh/diaoluo-gailv-yuanli",
    publicDir: "zh/diaoluo-gailv-yuanli",
    assetPrefix: "../../../build",
  },
};

export function guidePathForLocale(locale) {
  return (GUIDE_PAGES[locale] || GUIDE_PAGES.en).path;
}

export function guideHreflangAlternates() {
  return Object.values(GUIDE_PAGES).map(({ lang, path }) => ({
    lang,
    href: `${SITE_ORIGIN}${path}/`,
  }));
}
